import {Link, ModalLink, roles, trackAnalyticsEvent} from '@eitje/bridge'
import {ExternalLink} from '~/components/external_link'
import {BaseEitjeButton} from '../base_eitje_button'

export const EitjeButton = ({
	modalLink,
	to,
	externalLink,
	state,
	width,
	style,
	children,
	disabled,
	enableRole,
	roleEnv,
	ref,
	className,
	tabIndex,
	onClick,
	iconLeft,
	analytics,
	// Forwarding other BaseEitjeButton and Layout props
	...otherProps
}) => {
	const isDisabledByRole = roles.useRoleMessage({roles: enableRole, env: roleEnv})
	const isDisabled = isDisabledByRole || disabled
	const buttonProps = {
		...otherProps,
		width,
		ref,
		disabled: isDisabled,
	}

	const handleClick = e => {
		if (trackAnalyticsEvent && analytics) {
			trackAnalyticsEvent(analytics)
		}

		onClick?.(e)
	}

	const linkProps = {
		className,
		tabIndex,
		disabled: isDisabled,
		onClick: handleClick,
		style: {...(width?.includes?.('full') && {width: '100%'}), ...style},
	}

	if (modalLink)
		return (
			<ModalLink {...linkProps} to={modalLink}>
				<BaseEitjeButton {...buttonProps} className="modal-link-button" iconLeft={iconLeft}>
					{children}
				</BaseEitjeButton>
			</ModalLink>
		)

	if (to)
		return (
			<Link {...linkProps} to={to} state={state}>
				<BaseEitjeButton {...buttonProps} iconLeft={iconLeft}>
					{children}
				</BaseEitjeButton>
			</Link>
		)

	if (externalLink) {
		const {target, ...externalButtonProps} = buttonProps

		return (
			<ExternalLink {...linkProps} to={externalLink} target={target}>
				<BaseEitjeButton {...externalButtonProps} iconLeft={iconLeft ?? 'external-link'}>
					{children}
				</BaseEitjeButton>
			</ExternalLink>
		)
	}

	return (
		<BaseEitjeButton {...buttonProps} className={className} tabIndex={tabIndex} onClick={handleClick} iconLeft={iconLeft} style={style}>
			{children}
		</BaseEitjeButton>
	)
}
